import React from 'react'
import { withStyles } from '@material-ui/core'
import styles from './styles'

import CnameBanner from 'src/components/custom-domain/components/cname-banner'
const CustomDomainNonPremiumView = props => {
  return <CnameBanner />
}
export default withStyles(styles)(CustomDomainNonPremiumView)
